import Axios from "axios";
import { action, decorate, observable } from "mobx";
import ServerGridConfig from "../../../../config/ServerGridConfig";

export default class ManageReverseInvoicesStore {
	agGrid = null;
	per_page = ServerGridConfig.options.paginationPageSize;
	current_page = 1;
	list_data = null;
	editValues = null;
	deleteValues = null;
	statusValues = null;
	total = 0;
	allColumnIds = [];
	viewValues = null;
	dropdown_courier_vendor_list = null;
	summary_filter = null;
	daliyBookingValues = null;
	paymentsDetailValues = null;

	// set form values to edit
	setEditValues = (data) => {
		this.editValues = data;
	};

	// set form values to view
	setViewValues = (data) => {
		this.viewValues = data;
	};

	// set form values to delete
	setDeleteValues = (data) => {
		this.deleteValues = data;
	};

	// set form values to view
	setDaliyBookingValues = (data) => {
		this.daliyBookingValues = data;
	};

	// set form values to view
	setPaymentsDetailValues = (data) => {
		this.paymentsDetailValues = data;
	};

	refreshList = () => {
		if (this.agGrid) {
			this.setupGrid(this.agGrid);
		}
	}


	// Setup grid and set column size to autosize
	setupGrid = (params) => {
		this.agGrid = params;
		const { api } = params;
		let datasource = this.createDatasource(ServerGridConfig.options);
		api.setServerSideDatasource(datasource);
		// let pcode = localStorage.getItem("ho_inv_code");
		// if (pcode && pcode !== "") {
		// 	const filter = {'pcode': {  filterType: 'number', type :"contains", filter: pcode }}
		// 	this.agGrid.api.setFilterModel(filter);
		// 	localStorage.removeItem("ho_inv_code");
		// }
	};

	// change page size, default page size is LocalGridConfig.options.paginationPageSize
	setPageSize = (page = this.per_page) => {
		this.per_page = page;
		if (this.agGrid) {
			this.agGrid.api.paginationSetPageSize(parseInt(page));
		}
	};

	// set form values to  customefilter
	setOverviewFilterValues = (data) => {
		return new Promise((resolve) => {
			this.summary_filter = data;
			if (this.agGrid) {
				this.setupGrid(this.agGrid);
			}
			resolve()
		});
	};

	generatePayload = (summary_filter) => {
		return summary_filter;
	}


	// Create data source to display record in table
	createDatasource = (gridOptions) => {
		return {
			gridOptions,
			getRows: (params) => {
				var filter_data = this.changeFilterAndSort(params.request);
				var advance_filter = this.generatePayload(this.summary_filter);
				var payload = {
					advance_filter: advance_filter,
					filter_data: filter_data.final_filter,
					sort_data: filter_data.final_sort,
					per_page: params.request.endRow - params.request.startRow,
					page: Math.ceil(
						(params.request.startRow + 1) /
						(params.request.endRow - params.request.startRow)
					),
				};
				this.getList(payload).then((data) => {
					if (data.list.total === 0) {
						this.agGrid.api.showNoRowsOverlay();
					} else {
						this.agGrid.api.hideOverlay();
					}
					params.successCallback(data.list.data, data.list.total);
					var allColumnIds = [];
					if (this.agGrid && this.agGrid.columnApi && data.total) {
						this.agGrid.columnApi.getAllColumns().forEach(function (column) {
							allColumnIds.push(column.col_id);
						});
					}
				});
			},
		};
	};

	// call api to get records
	getList = (payload) => {
		return Axios.post(`/ho-activities/reverse-invoice/list`, payload).then(({ data }) => {
			if (data.list.data.length) {
				let startPage = (data.list.current_page - 1) * data.list.per_page;
				data.list.data.map((item, index) => {
					item.srno = startPage + index + 1;
					//     item.cities = item.cities && item.cities.name
					return null;
				});
			}

			this.list_data = data.list ? data.list.data : null;
			this.total = data.list.total;
			this.current_page = data.list.current_page;
			return data;
		});
	};

	// Filter function for no record found message
	changeFilterAndSort = (params) => {
		var final_filter = params.filterModel;
		var final_sort = params.sortModel;
		return { final_filter, final_sort };
	};

	// Filter function for no record found message
	onFilterChanged = (params) => {
		this.agGrid = params;
		if (this.agGrid && this.agGrid.api.getModel().getRowCount() === 0) {
			this.agGrid.api.showNoRowsOverlay();
		}
		if (this.agGrid && this.agGrid.api.getModel().getRowCount() > 0) {
			this.agGrid.api.hideOverlay();
		}
	};

	// set form values to  customefilter
	setAdvanceFilterValues = (data = null) => {
		this.advance_filter = data;
		if (this.agGrid) {
			this.setupGrid(this.agGrid);
		}
	};

	//setAdvanceFilter
	setAdvanceFilter = () => {
		let setAdvanceFilter = {};
		return setAdvanceFilter;
	}

	// Call delete api
	DeleteTaxInvoices = (formdata) => {
		return Axios.delete(`/ho-activities/reverse-invoice/cancellation/`  + formdata.id, 
		this.deleteValues?.is_perfoma === 1 ? { data: { is_perfoma: 1 }} : ''
		).then(({ data }) => {
				this.setupGrid(this.agGrid);
				return data;
			})
			.catch((response) => {
				return Promise.reject(response);
			});
	};

	// call api to get Payments Detail records
	PaymentsDetailData = (formdata) => {
		return Axios.post(
			`/invoice-get-payments/detail`, formdata
		).then(({ data }) => {
			this.setPaymentsDetailValues(data.detail)
			return data.detail;
		});
	};

	// call api to get records
	ViewData = (formdata) => {
		return Axios.post(
			`/ho-activities/reverse-invoice/detail`, formdata
		).then(({ data }) => {
			this.setViewValues(data.detail)
			return data.detail;
		});
	};

	doGenerateBillsPdf = (data) => {
		return Axios.post(`/ho-activities/reverse-invoice/print`, data)
			.then(({ data }) => {
				if (this.agGrid) {
					this.agGrid.api.deselectAll();
					this.setupGrid(this.agGrid);
				}
				return data;
			})
			.catch(({ response: { data } }) => {
				var errors = [];
				var notify = null;
				const { NOTIFICATION, ...fieldErrors } = data.STATUS;
				if (data && data.STATUS) {
					if (NOTIFICATION) {
						notify = NOTIFICATION[0];
					}
					Object.keys(fieldErrors).forEach((name) => {
						errors.push({ name, errors: data.STATUS[name] });
					});
				}
				return Promise.reject({ errors, notify });
			});
	};

	doExportDownloadDetail = (data) => {
		if (this.agGrid) {
			var filter = this.agGrid.api.getFilterModel();
			var sort = this.agGrid.api.getSortModel();
		}
		return Axios.post(`/ho-activities/reverse-invoice/list/export`, { data, filter, sort })
			.then(({ data }) => {
				return data;
			})
			.catch(({ response: { data } }) => {
				var errors = [];
				var notify = null;
				const { NOTIFICATION, ...fieldErrors } = data.STATUS;
				if (data && data.STATUS) {
					if (NOTIFICATION) {
						notify = NOTIFICATION[0];
					}
					Object.keys(fieldErrors).forEach((name) => {
						errors.push({ name, errors: data.STATUS[name] });
					});
				}
				return Promise.reject({ errors, notify });
			});
	};

	// Call add api
	GenerateTaxInvoice = (formdata) => {
		return Axios.post(`/ho-activities/reverse-invoice/generate`, formdata)
			.then(({ data }) => {
				this.setupGrid(this.agGrid);
				return data;
			})
			.catch(({ response: { data } }) => {
				var errors = [];
				var notify = null;
				const { NOTIFICATION, ...fieldErrors } = data.STATUS;
				if (data && data.STATUS) {
					if (NOTIFICATION) {
						notify = NOTIFICATION[0];
					}
					Object.keys(fieldErrors).forEach((name) => {
						errors.push({ name, errors: data.STATUS[name] });
					});
				}
				return Promise.reject({ errors, notify });
			});
	};

	// call api to get records
	DailyBookingsData = (ID) => {
		return Axios.get(
			`/ho-activities/reverse-invoice/daily-bookings/${ID}`
		).then(({ data }) => {
			this.setDaliyBookingValues(data.daily_bookings_json)
			return data.daily_bookings_json;
		});
	};

}

decorate(ManageReverseInvoicesStore, {
	per_page: observable,
	agGrid: observable,
	list_data: observable,
	editValues: observable,
	deleteValues: observable,
	total: observable,
	allColumnIds: observable,
	setupGrid: action,
	setPageSize: action,
	setEditValues: action,
	setDeleteValues: action,
	getList: action,
	onFilterChanged: action,
	setViewValues: action,
	viewValues: observable,
	setAdvanceFilterValues: action,
	setOverviewFilterValues: observable,
	overview_filter: action,
	summary_filter: observable,
	setDaliyBookingValues: action,
	daliyBookingValues: observable,	
	setPaymentsDetailValues: action,
	paymentsDetailValues: observable
});
